import React, { Component } from 'react';
import { Icon } from '@lyearn-team/frontend-components';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';

const activeClass = 'slick-slide slick-active block-flashcards-slider__slide';
const normalClass = 'slick-slide block-flashcards-slider__slide';
const buttonBeginningClass =
  'block-flashcards-slider__controls block-flashcards-slider__controls--beginning';
const buttonNormalClass = 'block-flashcards-slider__controls';
const buttonEndClass = 'block-flashcards-slider__controls block-flashcards-slider__controls--end';
const activeCardOpacity = 'activeCardOpacity';
const normalCardOpacity = 'normalCardOpacity';
const normalCard = 'normalCard';
const previousButtonClassDisplayNone = 'previous-button-display-none';
const nextButtonClassDisplayNone = 'next-button-display-none';
// this.position = 0;
// const styles = getStyles(); // eslint-disable-line no-use-before-define

class FlashCardStack extends Component {
  state = {
    isNextClick: false,
    currentCardPosition: 0,
    flipClass: 'block-flashcard--flipped',
    backFlippedCards: [],
    lessonId: this.props.lesson.id,
    showHint: true,
    width: NaN
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lesson.id !== prevState.lessonId) {
      return {
        backFlippedCards: [],
        lessonId: nextProps.lesson.id
      };
    }
    return null;
  }

  componentDidMount() {
    // this.updateWindowDimensions();
    this.resizeContainer = document.getElementsByClassName(
      'blockContainer blockContaier__full-width'
    )[0];
    this.updateContainerDimensions();
    this.resizeEventListener = new ResizeSensor(
      this.resizeContainer,
      this.updateContainerDimensions
    );
    // window.addEventListener('resize', this.updateWindowDimensions());
  }

  componentWillUnmount() {
    this.resizeEventListener.detach(this.resizeContainer);
    // window.removeEventListener('resize', this.updateWindowDimensions());
  }

  resizeContainer = null;

  updateContainerDimensions = () => {
    this.setState({ width: this.resizeContainer.offsetWidth });
  };

  updateWindowDimensions = () => () => {
    this.setState({ width: window.innerWidth });
  };

  showFront = index => () => {
    const temparry = this.state.backFlippedCards;
    temparry.push(index);
    this.setState({
      backFlippedCards: temparry,
      showHint: false
    });
  };

  showBack = index => () => {
    const temparry1 = this.state.backFlippedCards;

    const tempIndex = temparry1.indexOf(index);
    if (tempIndex > -1) {
      temparry1.splice(tempIndex, 1);
    }

    //  temparry1.splice(temparry1.indexOf(index) > -1, 1);
    this.setState({
      backFlippedCards: temparry1
    });
  };

  frontCard = (item, index) => {
    switch (item.front.type) {
      case 'description': {
        this.frontCardDescriptionSection(item, index);
        break;
      }
      case 'fullimage': {
        this.frontCardDescriptionSection(item, index);
        break;
      }
      case 'image': {
        this.frontCardDescriptionSection(item, index);
        break;
      }
      default:
        break;
    }
  };

  backCard = (item, index) => {
    switch (item.back.type) {
      case 'description': {
        this.backCardDescriptionSection(item, index);
        break;
      }
      case 'fullimage': {
        this.backCardFullimageSection(item, index);
        break;
      }
      case 'image': {
        this.backCardCenterimageSection(item, index);
        break;
      }
      default:
        break;
    }
  };

  frontCardDescriptionSection = (item, index) => (
    <div
      aria-hidden="false"
      className="block-flashcard__front block-flashcard__front--description"
      role="button"
      tabIndex="-1"
      onClick={this.showFront(index)}
    >
      <div className="block-flashcard__content brand-border-acent">
        {/* <div className={'block-flashcard__center brand--linkColor ' + (item.front.description.length > 80 ? 'block-flashcard__center--long block-flashcard__center--long--front block-flashcard__center--overflow' : '')} aria-label="Flashcard front - Front of card 1"> */}
        <div
          className="block-flashcard__center brand--linkColor block-flashcard__center--longnew"
          aria-label="Flashcard front - Front of card 1"
        >
          <div
            aria-hidden="false"
            className="block-flashcard__description brand--head brand--linkColor"
          >
            <div className="fr-view">{item.front.description}</div>
          </div>
        </div>
      </div>
      <div
        className="block-flashcard__flip brand--ui block-flashcard__flip--detailed"
        role="button"
        tabIndex="-1"
        onClick={this.showFront(index)}
      >
        <span className="flip-text">
          {this.props.lesson.settings.showHint && this.state.showHint && index === 0
            ? 'Click to flip '
            : ''}
        </span>
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="23" height="17" viewBox="0 0 23 17" focusable="false">
                          <path fillRule="nonzero" d="M19.347 8.275l1.88 1.714a.727.727 0 0 0 .98-1.074l-3.225-2.941a.727.727 0 0 0-1.027.047l-2.94 3.224a.727.727 0 0 0 1.075.98l1.802-1.976a6.545 6.545 0 0 1-11.56 4.288.727.727 0 1 0-1.114.935 8 8 0 0 0 14.129-5.197zm-16.039.162l-1.79-1.633a.727.727 0 1 0-.98 1.074l3.223 2.94c.297.272.757.25 1.028-.046l2.94-3.224a.727.727 0 0 0-1.075-.98L4.768 8.636a6.545 6.545 0 0 1 11.555-4.482.727.727 0 1 0 1.114-.936A8 8 0 0 0 3.308 8.437z"></path>
          </svg> */}
        </span>
      </div>
    </div>
  );

  frontCardFullimageSection = (item, index) => (
    <div
      aria-hidden="false"
      className="block-flashcard__front block-flashcard__front--fullimage"
      role="button"
      tabIndex="-1"
      onClick={this.showFront(index)}
    >
      <div
        className="block-flashcard__content"
        style={{ backgroundImage: 'url(' + item.front.media.image.src + ')' }}
      >
        <div className="block-flashcard__center brand--linkColor" aria-label="Flashcard front" />
      </div>
      <div
        className="block-flashcard__flip brand--ui"
        role="button"
        tabIndex="-1"
        onClick={this.showFront(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  frontCardCenterimageSection = (item, index) => (
    <div
      aria-hidden="true"
      className="block-flashcard__front block-flashcard__front--image"
      role="button"
      tabIndex="-1"
      onClick={this.showFront(index)}
    >
      <div className="block-flashcard__content">
        <div
          className="block-flashcard__center brand--linkColor block-flashcard__center--column"
          aria-label="Flashcard back"
        >
          <div
            className="block-flashcard__image"
            style={{ backgroundImage: 'url(' + item.front.media.image.src + ')' }}
          >
            {/* <img src="https://images.articulate.com/f:jpg|png,a:retain,b:fff/assets/rise/assets/block-defaults/mountains.jpg"> */}
          </div>
        </div>
      </div>
      <div
        className="block-flashcard__flip brand--ui"
        role="button"
        tabIndex="-1"
        onClick={this.showFront(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  backCardDescriptionSection = (item, index) => (
    <div
      aria-hidden="true"
      className="block-flashcard__back block-flashcard__back--description"
      role="button"
      tabIndex="-1"
      onClick={this.showBack(index)}
    >
      <div className="block-flashcard__content">
        {/* <div className={'block-flashcard__center brand--linkColor ' + (item.back.description.length > 80 ? 'block-flashcard__center--long block-flashcard__center--long--front block-flashcard__center--overflow' : '')} aria-label="Flashcard back - Back of card 1"> */}
        <div
          className="block-flashcard__center brand--linkColor block-flashcard__center--longnew"
          aria-label="Flashcard back - Back of card 1"
        >
          <div
            aria-hidden="true"
            className="block-flashcard__description brand--head brand--linkColor"
          >
            <div className="fr-view">{item.back.description}</div>
          </div>
        </div>
      </div>
      <div
        className="block-flashcard__flip brand--ui"
        role="button"
        tabIndex="-1"
        onClick={this.showBack(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  backCardFullimageSection = (item, index) => (
    <div
      aria-hidden="true"
      className="block-flashcard__back block-flashcard__back--fullimage"
      role="button"
      tabIndex="-1"
      onClick={this.showBack(index)}
    >
      <div
        className="block-flashcard__content"
        style={{ backgroundImage: 'url(' + item.back.media.image.src + ')' }}
      >
        <div className="block-flashcard__center brand--linkColor" aria-label="Flashcard back" />
      </div>
      <div
        className="block-flashcard__flip brand--ui block-flashcard__flip--detailed"
        role="button"
        tabIndex="-1"
        onClick={this.showBack(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  backCardCenterimageSection = (item, index) => (
    <div
      aria-hidden="true"
      className="block-flashcard__back block-flashcard__back--image"
      role="button"
      tabIndex="-1"
      onClick={this.showBack(index)}
    >
      <div className="block-flashcard__content">
        <div
          className="block-flashcard__center brand--linkColor block-flashcard__center--column"
          aria-label="Flashcard back"
        >
          <div
            className="block-flashcard__image"
            style={{ backgroundImage: 'url(' + item.back.media.image.src + ')' }}
          >
            {/* <img src="https://images.articulate.com/f:jpg|png,a:retain,b:fff/assets/rise/assets/block-defaults/mountains.jpg"> */}
          </div>
        </div>
      </div>
      <div
        className="block-flashcard__flip brand--ui"
        role="button"
        tabIndex="-1"
        onClick={this.showBack(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  nextButtonClick = index => () => {
    this.setState({
      isNextClick: true,
      currentCardPosition: this.state.currentCardPosition + 1,
      backFlippedCards: []
    });
  };

  previousButtonClick = index => () => {
    this.setState({
      isNextClick: false,
      currentCardPosition: this.state.currentCardPosition - 1,
      backFlippedCards: []
    });
  };

  render() {
    const { currentCardPosition, flipClass, width } = this.state;

    if (!width) {
      return null;
    }

    const items = this.props.lesson.items;
    // this.state.width = window.innerWidth;
    // console.log(width);
    const totalCart = this.props.lesson.items.length;
    const left = width + 10;
    // console.log(left + 'here');
    const totalWidth = totalCart * left;
    let position = 0;
    // console.log(items[0].front.description.length);
    if (currentCardPosition >= totalCart - 1) {
      position = totalCart - 1;
      this.state.currentCardPosition = position;
    } else {
      position = currentCardPosition;
    }
    if (currentCardPosition < 0) {
      position = 0;
      this.state.currentCardPosition = position;
    }
    const progressLength = (100 / totalCart) * (position + 1);
    return (
      <div className="block__content">
        <div
          aria-label="Flashcard stack"
          className="block-flashcards blocks-flashcard--stack"
          style={{ paddingTop: '30px', paddingBottom: '30px' }}
        >
          <section className="block-flashcards-slider block-flashcards-slider--full-carousel">
            <div className="block-flashcards-slider__wrap">
              <div className="slick-initialized slick-slider block-flashcards-slider__slides">
                <div
                  className={position === 0 ? previousButtonClassDisplayNone : buttonNormalClass}
                >
                  <div
                    aria-disabled="true"
                    aria-label="Previous flashcard"
                    className="block-flashcards-slider__arrow block-flashcards-slider__arrow--prev"
                    role="button"
                    tabIndex="-1"
                    onClick={this.previousButtonClick(1)}
                  >
                    <i className="icon">
                      <Icon type="angle-left" style={{ fill: '#4a90e2' }} />
                    </i>
                  </div>
                </div>

                <div className="slick-list">
                  <div
                    className="slick-track"
                    style={{
                      opacity: '1',
                      transform: 'translate3d(0px, 0px, 0px)',
                      width: totalWidth + 'px'
                    }}
                  >
                    {items.map((item, index) => (
                      <div
                        className={
                          index === position
                            ? activeClass + ' ' + normalCard + ' ' + activeCardOpacity
                            : normalClass + ' ' + normalCard + ' ' + normalCardOpacity
                        }
                        data-index="0"
                        tabIndex="-1"
                        key={index}
                        style={{ left: '-' + index * left + 'px', width: left + 'px' }}
                      >
                        <section
                          className={
                            'block-flashcard block-flashcard--large ' +
                            (this.state.backFlippedCards.indexOf(index) > -1 ? flipClass : '')
                          }
                        >
                          <div className="block-flashcard__wrapper">
                            {item.back.type === 'description'
                              ? this.backCardDescriptionSection(item, index)
                              : ''}
                            {item.back.type === 'fullimage'
                              ? this.backCardFullimageSection(item, index)
                              : ''}
                            {item.back.type === 'image'
                              ? this.backCardCenterimageSection(item, index)
                              : ''}
                            {item.front.type === 'description'
                              ? this.frontCardDescriptionSection(item, index)
                              : ''}
                            {item.front.type === 'fullimage'
                              ? this.frontCardFullimageSection(item, index)
                              : ''}
                            {item.front.type === 'image'
                              ? this.frontCardCenterimageSection(item, index)
                              : ''}
                          </div>
                        </section>
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  className={
                    currentCardPosition >= totalCart - 1
                      ? nextButtonClassDisplayNone
                      : buttonNormalClass
                  }
                >
                  <div
                    aria-disabled="true"
                    aria-label="Next flashcard"
                    className="block-flashcards-slider__arrow block-flashcards-slider__arrow--next"
                    role="button"
                    tabIndex="-1"
                    onClick={this.nextButtonClick(1)}
                  >
                    <i className="icon">
                      <Icon type="angle-right" style={{ fill: '#4a90e2' }} />
                    </i>
                  </div>
                </div>
              </div>

              <div
                className={
                  totalCart === 1 ? nextButtonClassDisplayNone : 'block-flashcards-slider__info'
                }
              >
                <div className="block-flashcards-slider__progress">
                  <p className="block-flashcards-slider__progress-text brand--body brand--linkColor">
                    {`${position + 1} of ${totalCart}`}
                  </p>
                  <div
                    className="block-flashcards-slider__progress-line next-previous-button"
                    style={{ width: progressLength + '%' }}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default FlashCardStack;
